export const moduleConfig = {
    entityKey: 'products',
    titles: {
        singular: 'Product',
        plural: 'Products'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};